<template>
  <div class="people" :class="`people-`+ color">
    <div class="photo-wrap">
      <div class="photo">
        <img :src="image" v-bind:alt="alt">
      </div>
    </div>
    <div class="text">
      <p class="background" v-html="background">
      </p>
      <p class="profile" v-html="profile">
      </p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import News from '@/components/News.vue';
export default {
  name: 'people-profile',
  props: {
    color: String,
    image: String,
    alt: String,
    background: String,
    profile: String,
  }
}
</script>

<style lang="scss" scoped>
.people {
  max-width: 190px;
  width: 100%;
  font-size: 12px;
  margin: 0 20px;
  @media print, screen and (max-width: 1160px) {
    display: flex;
    max-width: 100%;
    margin: 0;
    margin-bottom: 30px;
  }
  &.people-orange {
    .background {
      color: #ff6b00;
    }
    .photo-wrap {
      &:after {
        border-bottom: 20px solid #ff6b00;
      }
    }
  }
  &.people-blue {
    .background {
      color: #2e8fff;
    }
    .photo-wrap {
      &:after {
        border-bottom: 20px solid #2e8fff;
      }
    }
  }
  &.people-pink {
    .background {
      color: #ff6080;
    }
    .photo-wrap {
      &:after {
        border-bottom: 20px solid #ff6080;
      }
    }
  }
  &.people-yellow {
    .background {
      color: #9c6b00;
    }
    .photo-wrap {
      &:after {
        border-bottom: 20px solid #9c6b00;
      }
    }
  }
  &.people-red {
    .background {
      color: #bc0036;
    }
    .photo-wrap {
      &:after {
        border-bottom: 20px solid #bc0036;
      }
    }
  }
  &.people-green {
    .background {
      color: #003f52;
    }
    .photo-wrap {
      &:after {
        border-bottom: 20px solid #003f52;
      }
    }
  }
  &.people-navy {
    .background {
      color: #2e3ea7;
    }
    .photo-wrap {
      &:after {
        border-bottom: 20px solid #2e3ea7;
      }
    }
  }
  .photo-wrap {
    position: relative;
    @media print, screen and (max-width: 1160px) {
      margin-right: 5%;
    }
    &:after {
      content: "";
      border: 8px solid transparent;
      border-bottom: 20px solid #000;
      width: 0;
      height: 0;
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      bottom: -10px;
      @media print, screen and (max-width: 1160px) {
        bottom: unset;
        top: 83px;

      }
    }
  }
  .photo {
    overflow: hidden;
    border-radius: 100%;
    width: 125px;
    height: 125px;
    margin-bottom: 30px;
    position: relative;
    margin: 0 auto;
    @media print, screen and (max-width: 1160px) {
      width: 100px;
      height: 100px;
    }
  }
  .background {
    @media print, screen and (max-width: 1160px) {
      margin-top: 0px;
    }
  }
  .profile {
    text-align: justify;
  }
}
</style>
